// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon___2oVY7","hasCursor":"hasCursor___2qyeh","content":"content___-KhJe","isFlipped":"isFlipped___2x1Vc","rotates":"rotates___3tvhO","rotating":"rotating___wu5BD"};